module.exports = __webpack_public_path__ + "static/media/send_to_wms_icon.7fc1d969.svg";